var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MyADGJobPopup.jinja');
require('./MyADGJobPopup.less');

var moment = require('moment/moment');

var CommonCalendar = require('front/components/CommonCalendar/CommonCalendar');
var CommonCalendarTemplate = require('front/components/CommonCalendar/CommonCalendarRuntime.jinja');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        // 'click .MyADGJobPopup-thanksClose': 'close', //function from BasePopup proto
        'input .MyADGJobPopup-stageStart input': 'onInputChangeStart',
        'input .MyADGJobPopup-stageStart textarea': 'onInputChangeStart',
        'change .MyADGJobPopup-stageStart input[type="radio"]': 'onInputChangeStart',
        'change .MyADGJobPopup-stageStart input[type="checkbox"]': 'onInputChangeStart',

        'change input[name="crew-list"]': 'onFileInputChange',
        'click .MyADGJobPopup-formInputWrapper-filename-delete': 'onFileDeleteClick',
        'change input[type="radio"]': 'onRadioChange',

        'input .MyADGJobPopup-stageEnd input': 'onInputChangeEnd',
        'input .MyADGJobPopup-stageEnd textarea': 'onInputChangeEnd',
        'change .MyADGJobPopup-stageEnd input[type="radio"]': 'onInputChangeEnd',
        'change .MyADGJobPopup-stageEnd input[type="checkbox"]': 'onInputChangeEnd',

        'click .MyADGJobPopup-formInputWrapper-datePicks': 'onCalendarClick',

        'click .MyADGJobPopup-back': 'goBackStage',
        'click .MyADGJobPopup-stageStart-1-buttons-button': 'goStage2',

        'click .MyADGJobPopup-stageStart-2-btn': 'onSubmitForm',
        'click .MyADGJobPopup-stageEnd-2-btn': 'onSubmitForm',
    }, BasePopup.prototype.baseEvents),

    tempFilesApi: function () {
        return Urls['front:api:files:temp-file-upload']();
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    // apiUrl: function () {
    //     return Urls['member:api:job-start']('json');
    // },


    initialize: function (options) {
        this.options = options || {};

        this.inputValues = {};

        BasePopup.prototype.initialize.call(this, options);
    },


    onFileInputChange: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.resetFileLoading();

        var $input = $(e.currentTarget);
        var $wrapper = $input.closest('.MyADGJobPopup-formInputWrapper');
        var $filenameWrapper = $wrapper.find('.MyADGJobPopup-formInputWrapper-filename');
        var $filename = $filenameWrapper.find('.MyADGJobPopup-formInputWrapper-filename-name');
        var fil = e.target.files[0];
        var self = this;

        $filenameWrapper.attr('data-state', 'loading');
        $input.attr('data-file', '');
        $filename.text(fil.name);

        this.fileLoadXhr = new XMLHttpRequest();
        this.fileLoadXhr.open('POST', this.tempFilesApi());

        this.fileLoadXhr.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'file');

            $input.attr('data-file', JSON.stringify(responseObject));
            $filenameWrapper.attr('data-state', 'loaded');
        };

        this.fileLoadXhr.onerror = function () {
            $filenameWrapper.attr('data-state', 'error');
        };

        var formData = new FormData();
        formData.append('file', fil);
        this.fileLoadXhr.send(formData);

        $input.val('');
    },


    onFileDeleteClick: function (e) {
        var $wrapper = $(e.currentTarget).closest('.MyADGJobPopup-formInputWrapper');
        var $input = $wrapper.find('input[type="file"]');
        var $filenameWrapper = $wrapper.find('.MyADGJobPopup-formInputWrapper-filename');
        var $filename = $filenameWrapper.find('.MyADGJobPopup-formInputWrapper-filename-name');

        $filenameWrapper.attr('data-state', 'empty');
        $input.attr('data-file', '');
        $filename.text('');

        this.resetFileLoading();
    },


    resetFileLoading: function () {
        this.fileLoadXhr && this.fileLoadXhr.abort();
    },


    viewsRegistration: function () {
        this.$('.MyADGJobPopup-memberName').text(app.settings.memberName);

        this.$wrapperStage1 = $('.MyADGJobPopup-stageStart-1');

        this.$wrapperStageStart2 = $('.MyADGJobPopup-stageStart-2');
        this.$wrapperStageEnd2 = $('.MyADGJobPopup-stageEnd-2');

        this.$wrapperThanks = $('.MyADGJobPopup-thanks');

        var dateFrom = moment().startOf('day');

        $('.MyADGJobPopup-formInputWrapper-date')
            .attr('data-date', dateFrom.toISOString())
            .find('span')
            .text(dateFrom.format('MM/DD/YY'));

        $('.MyADGJobPopup-formInputWrapper-date-end')
            .attr('data-date', dateFrom.toISOString())
            .find('span')
            .text(dateFrom.format('MM/DD/YY'));

        $('.MyADGJobPopup-formInputWrapper-date-hiatus')
            .attr('data-date', dateFrom.toISOString())
            .find('span')
            .text(dateFrom.format('MM/DD/YY'));

        $(window).on('resize', this.onResize);
        this.onResize();

        BasePopup.prototype.viewsRegistration.call(this);
    },

    onResize: function () {
        this.setHeightPopup();

        BasePopup.prototype.onResize.call(this);
    },

    setHeightPopup: function () {
        var marTop = 0;
        var hStage = 0;
        var hWindow = $(window).innerHeight();

        if (app.settings.isPhone) return;

        $('.MyADGJobPopup-stage').each(function () {
            marTop = 0;
            hStage = 0;
            hStage = $(this).innerHeight();
            marTop = Math.max(((hWindow - hStage) / 2), 60);
            $(this).css('padding-top', marTop + 'px');
        });
    },


    goBackStage: function (e) {
        var stage = $(e.currentTarget).data('prev');

        $('.MyADGJobPopup-stage').each(function () {
            $(this).addClass('hidden');
        });
        $('.MyADGJobPopup-stage').outerHeight();

        $('.MyADGJobPopup-stage' + stage).removeClass('hidden');

        this.resetFileLoading();
    },

    goStage2: function (e) {
        this.type = $(e.currentTarget).data('type');

        this.$wrapperStage1.addClass('hidden');
        $('.MyADGJobPopup-stage').outerHeight();

        if (this.type == 'start') {
            this.$wrapperStageStart2.removeClass('hidden');
        } else if (this.type == 'end') {
            this.$wrapperStageEnd2.removeClass('hidden');
        }
    },


    goStageThanks: function () {
        var classType = '';
        var data;

        if (this.type == 'start') {
            data = this.getFormDataStart();
            classType = 'Start';

            if (!data.valid) return;

            this.$wrapperStageStart2.addClass('hidden');
        } else {
            data = this.getFormDataEnd();
            classType = 'End';

            if (!data.valid) return;

            this.$wrapperStageEnd2.addClass('hidden');
        }
        $('.MyADGJobPopup-stage').outerHeight();

        this.$wrapperThanks
            .addClass('MyADGJobPopup-stage' + classType)
            .removeClass('hidden');
    },


    onSubmitForm: function () {
        var data;
        var urlApi;

        if (this.type == 'start') {
            data = this.getFormDataStart();
            urlApi = Urls['member:api:job-start']('json');
        } else {
            data = this.getFormDataEnd();
            urlApi = Urls['member:api:job-complete']('json');
        }

        if (!data.valid) return;

        this._xhr = $.ajax({
            'url': urlApi,
            'data': JSON.stringify(data.data),
            'contentType': 'application/json; charset=utf-8',
            'dataType': 'json',
            'method': 'POST',
            'success': function () {
                this.goStageThanks();
            }.bind(this),
            'error': function () {
                alert('Something went wrong, try again later.');
            }.bind(this),
            'context': this
        });
    },


    onInputChangeStart: function (e) {
        var data = this.getFormDataStart();

        this.$('.MyADGJobPopup-stageStart').toggleClass('MyADGJobPopup-stageStart--filled', !!data.valid);
    },


    getFormDataStart: function () {
        var production = this.$('input[name="production"]').val();
        var productionCompany = this.$('input[name="productionCompany"]').val();
        var typeOfProduction = this.$('input[name="typeOfProduction"]').val();
        var startDate = this.$('.MyADGJobPopup-formInputWrapper-date').attr('data-date');
        var position = this.$('input[name="position"]').val();
        var union = this.$('input[name="union"]:checked').val();
        var comments = this.$('textarea[name="comments"]').val();
        var crewList = this.$('.MyADGJobPopup-stageStart input[type="file"]').attr('data-file');

        var productionDesigner = this.$('input[name="productionDesigner"]').val();
        var departamentLocation = this.$('input[name="departamentLocation"]').val();
        var departamentCoordinator = this.$('input[name="departamentCoordinator"]').val();
        var phone = this.$('input[name="phone"]').val();
        var projectDuration = this.$('input[name="projectDuration"]').val();
        var negotiatedRate = this.$('input[name="negotiatedRate"]').val();
        var rentals = this.$('input[name="rentals"]').val();
        var boxRate = this.$('input[name="boxRate"]').val();
        var capped = (this.$('input[name="capped"]:checked').val()) ? true : false;

        return {
            valid: production && productionCompany && typeOfProduction && startDate && position && (union !== undefined),
            data: {
                production: production,
                productionCompany: productionCompany,
                typeOfProduction: typeOfProduction,
                startDate: startDate,
                position: position,
                union: union,
                comments: comments,
                crewList: crewList ? JSON.parse(crewList) : null,
                productionDesigner: productionDesigner,
                departamentLocation: departamentLocation,
                departamentCoordinator: departamentCoordinator,
                phone: phone,
                projectDuration: projectDuration,
                negotiatedRate: negotiatedRate,
                rentals: rentals,
                boxRate: boxRate,
                capped: capped
            }
        };
    },

    onInputChangeEnd: function (e) {
        var data = this.getFormDataEnd();

        this.$('.MyADGJobPopup-stageEnd').toggleClass('MyADGJobPopup-stageEnd--filled', !!data.valid);
    },


    getFormDataEnd: function () {
        var production = this.$('input[name="production-end"]').val();
        var productionCompany = this.$('input[name="productionCompany-end"]').val();
        var typeOfProduction = this.$('input[name="typeOfProduction-end"]').val();
        var finishDate = this.$('.MyADGJobPopup-formInputWrapper-date-end').attr('data-date');
        var position = this.$('input[name="position-end"]').val();
        var union = this.$('input[name="union-end"]:checked').val();
        var hiatus = this.$('input[name="hiatus"]:checked').val();
        var completed = this.$('input[name="completed"]:checked').val();
        var dateHiatus = this.$('.MyADGJobPopup-formInputWrapper-date-hiatus').attr('data-date');
        var crewList = this.$('.MyADGJobPopup-stageEnd input[type="file"]').attr('data-file');

        var productionDesigner = this.$('input[name="productionDesigner-end"]').val();
        var departamentLocation = this.$('input[name="departamentLocation-end"]').val();
        var departamentCoordinator = this.$('input[name="departamentCoordinator-end"]').val();
        var phone = this.$('input[name="phone-end"]').val();
        var comments = this.$('textarea[name="comments-end"]').val();

        return {
            valid: production && productionCompany && typeOfProduction && finishDate && position && (union !== undefined) && dateHiatus && (completed !== undefined) && (hiatus !== undefined),
            data: {
                production: production,
                productionCompany: productionCompany,
                typeOfProduction: typeOfProduction,
                finishDate: finishDate,
                position: position,
                union: union,
                hiatus: hiatus,
                dateHiatus: dateHiatus,
                completed: completed,
                crewList: crewList ? JSON.parse(crewList) : null,
                productionDesigner: productionDesigner,
                departamentLocation: departamentLocation,
                departamentCoordinator: departamentCoordinator,
                phone: phone,
                comments: comments
            }
        };
    },

    onCalendarClick: function (e) {
        var $date = $(e.currentTarget);
        var type = $date.attr('data-type');
        var $item = $date.closest('.MyADGJobPopup-formInputWrapper-' + type);

        if ($date.hasClass('MyADGJobPopup-formInputWrapper-' + type + '--calendar-opened')) {
            return;
        }

        var $calendar = $(CommonCalendarTemplate.render({data: {}}));

        $date.append($calendar);

        $date.addClass('MyADGJobPopup-formInputWrapper-' + type + '--calendar-opened');

        var calendar = new CommonCalendar({
            el: $calendar[0],
            date: $date.attr('data-date'),
            allowPastDates: true,
            warning: ''
        });


        var top = $calendar[0].getBoundingClientRect().top;

        if (top < 20) {
            $calendar.css('margin-bottom', top - 20);
        }


        calendar.show();

        calendar.on('close', function () {
            calendar.off();
            $date.removeClass('MyADGJobPopup-formInputWrapper-' + type + '--calendar-opened');
        });

        calendar.on('select', function (date) {
            var dateFrom = moment(date).startOf('day');

            $('.MyADGJobPopup-formInputWrapper-' + type)
                .attr('data-date', dateFrom.toISOString())
                .find('span')
                .text(dateFrom.format('MM/DD/YY'));

        }.bind(this));
    },


    deactivate: function (params) {
        this.resetFileLoading();

        return BasePopup.prototype.deactivate.call(this, params);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MyADGJobPopup/MyADGJobPopup.js
// module id = 288
// module chunks = 0